import { onMount } from "solid-js";
import { logPageLoad } from "../../../../../utils/logging";

export default function Probability() {
  onMount(() => {
    void logPageLoad("Probability.tsx", "Histogram Analysis Report", "Loaded");
  });
  return (
    <div class="probability">
      <p>Historical probability data goes here</p>
    </div>
  );
}
